import { addCryptoWallet, setCryptoWallets } from '../reducers/cryptoWalletsReducer';

export const addedCryptoWallet = (dispatch, wallet) => {
  dispatch(addCryptoWallet(wallet));
};

export const removeCryptoWallet = (key) => ({
  type: 'cryptoWallets/removeCryptoWallet',
  payload: { key }
});

export const removeCryptoWalletAll = () => ({
  type: 'cryptoWallets/removeCryptoWalletAll',
});

export const updateCryptoWallets = (dispatch, wallets) => {
  dispatch(setCryptoWallets(wallets));
}

